
































import { Component, Vue } from "vue-property-decorator";
import { SurveyModule } from "@/store";
import { SurveyType } from "@/interfaces";

@Component
export default class Governance extends Vue {
  @SurveyModule.bindings.Mutation
  setSurveyType!: (type: SurveyType | null) => void;

  loading = false;

  mounted() {
    this.setSurveyType(SurveyType.GOVERNANCE);
  }
}
